import onResize from '../utils/onResize';
import emitter from './emitter';

let menuOpen = false;

const toggleMenu = () => {
    // ie11 don't support classlist.toggle so roll our own.
    const func = menuOpen ? 'remove' : 'add';
    document.documentElement.classList[func]('menu-open');
    menuOpen = !menuOpen;
};

const closeMenu = () => {
    if (menuOpen) {
        if (document.activeElement.tagName.toLowerCase() !== 'input') {
            toggleMenu();
        }
    }
};

const registerMenuToggles = () => {
    [...document.querySelectorAll('.menu-toggle')].forEach(el => {
        el.addEventListener('click', toggleMenu);
    });
};

export default function initMainMenu() {
    registerMenuToggles();
    onResize(closeMenu);
    emitter.on('mobile-menu:close', closeMenu);
}
